export const lowerExtremityFunctionalScaleEn = {
  promInstructions:
    "Today, do you or would you have any difficulty at all with:",
  scaleEndLabel: "No Difficulty",
  scaleStartLabel: "Extreme Difficulty",
  scaleLabels: [
    "Extreme difficulty or unable to perform activity",
    "Quite a bit of difficulty",
    "Moderate difficulty",
    "A little bit of difficulty",
    "No difficulty",
  ],
  questions: [
    "Any of your usual work, housework, or school activities.",
    "Your usual hobbies, recreational or sporting activities.",
    "Getting into or out of the bath.",
    "Walking between rooms.",
    "Putting on your shoes or socks.",
    "Squatting.",
    "Lifting an object, like a bag of groceries from the floor.",
    "Performing light activities around your home.",
    "Performing heavy activities around your home.",
    "Getting into and out of a car.",
    "Walking 2 blocks.",
    "Walking a mile.",
    "Going up and down 10 stairs (about 1 flight of stairs).",
    "Standing for 1 hour.",
    "Sitting for 1 hour.",
    "Running on even ground.",
    "Running on uneven ground.",
    "Making sharp turns while running fast.",
    "Hopping.",
    "Rolling over in bed.",
  ],
};
